import { Component, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AssessmentmanagerService } from 'src/app/services/assessments/assessmentmanager.service';
import { ComponentheaderService } from 'src/app/services/componentheader.service';

declare var $;
@Component({
  selector: 'app-assessment-marksheet',
  templateUrl: './assessment-marksheet.component.html',
  styleUrls: ['./assessment-marksheet.component.css']
})
export class AssessmentMarksheetComponent implements OnInit {

  assessmentID:number;
  classID:number;
  batchID:number;
  dataTable: any;
  dtOptions: any;
  tableData = [];
  @ViewChild('dataTable', {static: true}) table;

  constructor( private assessmentmanager : AssessmentmanagerService , private router : Router ,private header : ComponentheaderService, private activatedroute : ActivatedRoute) {

    this.assessmentID = this.activatedroute.snapshot.queryParams.aid;
    this.classID = this.activatedroute.snapshot.queryParams.classid;
    this.batchID = this.activatedroute.snapshot.queryParams.batchid;


  }

  ngOnInit(): void {
    this.header.pageLoadingStarted(this);

    this.assessmentmanager.getAssessmentBreadCrumb(this.assessmentID).toPromise().then(
      (response:any)=>{
        this.header.setHeaderDisplay( ` ${response.assessmentName}:`,
        [
          {
            displaytext: 'School',
            route: `/user/schoolhome`,
            params: { schoolID: response.schoolID }
          },
          {
            displaytext: 'Course',
            route: `/user/moduledetails`,
            params: { moduleID: response.moduleID }
          },
          {
            displaytext: 'Lesson' ,
            route: `/user/lesson`,
            params: { classid: this.classID }
          },
          {
            displaytext: "Assessments",
            route: `/user/assessmentconsole`,
            params: { classid: this.classID,batchid:this.batchID }
          },
          {
            displaytext: response.assessmentName,
            route: `/user/assessmentdetails`,
            params: { classid: this.classID,batchid:this.batchID, aid: response.assessmentID },
          },
          {
            displaytext: "Marksheet",
            route: `/user/assessmentmarksheet`,
            params: { classid: this.classID, aid: this.assessmentID }
          },
        ],
        []);

      }
    );
    this.getDataFromSource();


  }

  getDataFromSource() {
    this.assessmentmanager.getAssessmentMarksheet(this.assessmentID,this.batchID).subscribe(
      (response:any)=>{
        this.tableData = response.data.items;
        this.dtOptions = {
          data: this.tableData,
          columns: [
            {title: 'S/No', data: 'count'},
            {title: 'Student', data: 'name'},
            {title: 'Score', data: 'score'}
          ],
          dom: 'Bfrtip',
            // Configure the buttons
            buttons: [
              'excel'
            ]
        };
        this.header.pageLoadingDone(this);
      }, err => {}, () => {
        this.dataTable = $(this.table.nativeElement);
        this.dataTable.DataTable(this.dtOptions);
      }
     );

  }

}
